import { createSlice, Reducer } from '@reduxjs/toolkit';

// Define the type for the state
export interface ResetState {
  reset: number;
}

// Define the initial state with the type
const initialState: ResetState = {
  reset: 0,
};

// Define the slice
const resetSlice = createSlice({
  name: 'reset',
  initialState,
  reducers: {
    globalReset: (state) => {
      state.reset += 1;
    },
  },
});

// Export the actions and the reducer
export const { globalReset } = resetSlice.actions;
export default resetSlice.reducer;

type CreateResetMetaReducer = (
  resetActionType: string,
  resetSlices: string[],
) => (reducer: Reducer<any, any>) => (state: any, action: any) => any;

// Define the meta reducer creator function with types
export const createResetMetaReducer: CreateResetMetaReducer = (
  resetActionType,
  resetSlices,
) => {
  return (reducer) => (state, action) => {
    if (action.type === resetActionType) {
      // Create a new state object with the specified slices reset to their initial state
      const resetState = resetSlices.reduce(
        (acc, sliceName) => {
          acc[sliceName] = reducer(undefined, { type: '@@RESET' });
          return acc;
        },
        {} as Record<string, any>,
      ); // Adjust the type if you have a more specific structure

      return { ...state, ...resetState };
    }

    return reducer(state, action);
  };
};
